"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var PublicStyleContext_1 = require("../RenderTokensHost/PublicStyleContext");
var react_1 = __importStar(require("react"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var sanitizeContent = function (content) {
    var _a;
    var strippedContent = (_a = content === null || content === void 0 ? void 0 : content.replace(/\r/g, "")) !== null && _a !== void 0 ? _a : "";
    return strippedContent;
};
var Text = function (_a) {
    var _b;
    var token = _a.token;
    var _c = (0, PublicStyleContext_1.usePublicStyleContext)(), blockStyles = _c.blockStyles, colorProvider = _c.colorProvider;
    var computeForegroundColor = undefined;
    var tokenContent = token["content"];
    var sanitizedContent = (0, react_1.useMemo)(function () { return sanitizeContent(tokenContent); }, [tokenContent]);
    var textStyle = {};
    if (token["style"]) {
        if (token["style"].bold) {
            textStyle.fontWeight = "bold";
        }
        if (token["style"].italic) {
            textStyle.fontStyle = "italic";
        }
        if (token["style"].strikethrough) {
            textStyle.textDecoration = "line-through";
        }
        if (token["style"].color) {
            textStyle.color = colorProvider.decorateColor((0, GetBlockStyle_1.convertColorObjToColor)(token["style"].color)).value;
        }
    }
    var hasStrikethrough = (_b = token["style"]) === null || _b === void 0 ? void 0 : _b.strikethrough;
    var spanClassName = hasStrikethrough ? "strikethrough" : undefined;
    return (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
            if (token["href"] != null) {
                var linkStyle = {};
                if (computeForegroundColor) {
                    var linkColor = blockStyles ? blockStyles["link"].color : undefined;
                    var decoratedLinkColor = linkColor
                        ? colorProvider.decorateColor((0, GetBlockStyle_1.convertColorObjToColor)(linkColor)).value
                        : "#000000";
                    var computedColor = computeForegroundColor(decoratedLinkColor);
                    linkStyle = {
                        color: computedColor,
                        borderBottomColor: computedColor,
                    };
                }
                var href = (0, URL_1.isURL)(token["href"], true) ? token["href"] : "#";
                return (react_1.default.createElement("a", { href: href, target: "_blank", rel: "noreferrer", style: linkStyle }, children));
            }
            return children;
        } },
        react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                if (token["style"]) {
                    return (react_1.default.createElement("span", { style: textStyle, className: spanClassName }, children));
                }
                return;
            } }, sanitizedContent)));
};
exports.Text = Text;
